import {
  ChangePasswordPayload,
  UpdateUserSettingsPayload,
} from "../types/settings.definition";
import {
  UpdateProfileImageRequest,
  changePassword,
  requestUpdateProfileImage,
  updateUserSettings,
} from "../webclients/user.client";

export const userApi = {
  /**
   * Update user settings (notifications, preferences, etc.)
   */
  updateUserSettings: async (
    userId: string,
    data: UpdateUserSettingsPayload
  ) => {
    const response = await updateUserSettings(userId, data);
    return response.data;
  },

  /**
   * Change user password
   */
  changePassword: async (data: ChangePasswordPayload) => {
    const response = await changePassword(data);
    return response.data;
  },

  /**
   * Update user profile image
   */
  updateProfileImage: async (
    userId: string | number,
    data: UpdateProfileImageRequest
  ): Promise<void> => {
    await requestUpdateProfileImage(userId, data);
  },
};

export default userApi;
